import {
    Button,
    makeStyles,
    mergeClasses,
    tokens,
} from "@fluentui/react-components";

type Props = {
    loginBtnClick: () => Promise<void>;
};

export default function MicrosoftLogin({ loginBtnClick }: Props) {
    const styles = useStyles();

    return (
        <div className={mergeClasses("auth", styles.auth)}>
            <h3>Welcome to Dynizer app!</h3>
            <p>
                Please click on "Start Dynizer" and consent permissions to use
                the app.
            </p>
            <Button appearance="primary" onClick={() => loginBtnClick()}>
                Start Dynizer
            </Button>
        </div>
    );
}

const useStyles = makeStyles({
    auth: {
        backgroundColor: tokens.colorNeutralBackground3,
    },
});
